import { render, staticRenderFns } from "./quotation-without-order.vue?vue&type=template&id=55e6ed80"
import script from "./quotation-without-order.vue?vue&type=script&lang=js"
export * from "./quotation-without-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports